var map = {
	"./icons/blog.png": 3993,
	"./icons/blogalt.png": 6012,
	"./icons/download.png": 9193,
	"./icons/gh.png": 8368,
	"./icons/linkedin.png": 6871,
	"./icons/web.png": 9763,
	"./projects/blog.png": 995,
	"./projects/buffboys.png": 9157,
	"./projects/edufi-timetable.gif": 5461,
	"./projects/monopoly.webp": 9485,
	"./projects/newspaper.png": 2462,
	"./projects/ooper.gif": 8183,
	"./projects/payorpray.png": 3798,
	"./projects/portfolio.gif": 9332,
	"./projects/simpcity.png": 8641,
	"./projects/skyhelix-helper.png": 545,
	"./tech/JavaScript.png": 204,
	"./tech/cicd.png": 2972,
	"./tech/cplusplus.png": 5686,
	"./tech/csharp.png": 5652,
	"./tech/docker.png": 7717,
	"./tech/golang.png": 3091,
	"./tech/html.png": 7962,
	"./tech/java.png": 8257,
	"./tech/microservice.png": 224,
	"./tech/pwa.png": 7941,
	"./tech/python.png": 7643,
	"./tech/react.png": 3808,
	"./tech/rust.png": 6999,
	"./tech/sql.png": 397,
	"./tech/vue.png": 4041
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7909;